import React from 'react';
import PropTypes from 'prop-types';
import { List, ListItem, ListItemIcon, ListItemText, SvgIcon } from '@material-ui/core';
import { ClientsIcon2 } from 'sharedComponents/Icons';
import useStyles from './GroupList.styles';

export const GroupItem = ({ groupId, name, coverColor, clientsCount, redirectToGroupPage }) => {
  const classes = useStyles({ coverColor });

  return (
    <ListItem className={classes.item} onClick={() => redirectToGroupPage(groupId, clientsCount)}>
      <ListItemIcon classes={{ root: classes.itemIcon }}>
        <SvgIcon component={ClientsIcon2} viewBox="0 0 20 20" />
      </ListItemIcon>
      <ListItemText primary={name} secondary={`${clientsCount} clients`} />
    </ListItem>
  );
};

const GroupList = ({ groups, redirectToGroupPage }) => {
  return (
    <List>
      {groups.map((group, index) => (
        <GroupItem key={group.groupId || `group_${index}`} redirectToGroupPage={redirectToGroupPage} {...group} />
      ))}
    </List>
  );
};

const ClientGroupPropType = PropTypes.shape({
  groupId: PropTypes.string,
  description: PropTypes.string,
  coverColor: PropTypes.string,
  name: PropTypes.string,
  clientsCount: PropTypes.number,
  averageAnnualAmount: PropTypes.number,
  yearPurchasesAmount: PropTypes.number,
  creationTime: PropTypes.string,
  defaultGroup: PropTypes.bool,
});

GroupList.propTypes = {
  groups: PropTypes.arrayOf(ClientGroupPropType),
  redirectToGroupPage: PropTypes.func,
};

GroupList.defaultProps = {
  groups: [],
  redirectToGroupPage: () => null,
};

export default GroupList;
